import { useEffect, useMemo, useState, useRef } from "react";
import _ from "underscore";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { useEmployeFilter } from "../../../context/EmployeFilterContext";
import { convertTo12HourFormat, dateConvert, timeStringToDate } from "../../../utils/Helper";
import { callautopopulate } from "../../../services/callautopop";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip from "bootstrap/js/dist/tooltip";

export const useAttendanceTracker = ({ callApi, worklogDate, setWorklogDate }) => {
    const { selectedEmployee } = useEmployeFilter();
    const [date, setDate] = useState(new Date( worklogDate ? worklogDate : ""));
    const [loader, setLoader] = useState(false)
    const [attendanceData, setAttendanceData] = useState([]);
    const [regularizationPopup, setRegularizationPopup] = useState({ show: false, data: null })
    const [userCode, setUserCode] = useState(null);
    const calendarDate = useRef({ month: new Date( worklogDate ? worklogDate : "")?.getMonth(), year: new Date(worklogDate ? worklogDate : "")?.getFullYear() });

    useEffect(() => {
        callautopopulate("user_info").then(async res => {
            setUserCode(res?.user_info?.[0]?.user_code);
        });
    }, [])

    useEffect(() => {
        if (!_.isEmpty(selectedEmployee)) {
            getMyAttendanceSummary()
        }
    }, [selectedEmployee, callApi])

    const getMyAttendanceSummary = async () => {
        setLoader(true);
        setDate(new Date(calendarDate?.current?.year, calendarDate?.current?.month + 1, 0));
        setWorklogDate(new Date(calendarDate?.current?.year, calendarDate?.current?.month + 1, 0));
        const payload = {
            "month": calendarDate?.current?.month + 1,
            "year": calendarDate?.current?.year,
            "requested_user_code": selectedEmployee?.user_code
        }
        try {
            const res = await services.getInvokeRemote('POST', Urls('GETMYATTENDANCESUMMARY'), payload);
            const data = res?.body?.data?.myattendance_summary;
            const pendingSummary = res?.body?.data?.myacction_pending_summary
            const lastDay = new Date(calendarDate?.current?.year, calendarDate?.current?.month + 1, 0)?.getDate();
            let formattedData = [];
            for (let i = 1; i <= lastDay; i++) {
                const dateValue = dateConvert(timeStringToDate("00:00:00", new Date(new Date(calendarDate?.current?.year, calendarDate?.current?.month + 1, 0).setDate(i))), "iso-string")?.split(".")?.[0];
                const dataValue = _.findWhere(data, { day_date: dateValue });
                const pendingObj = _.findWhere(pendingSummary, { shift_date: dateValue });
                let obj = {};

                if (!_.isEmpty(dataValue) && pendingObj?.day_box_status) {
                    obj = { ...dataValue, ...pendingObj, pending: true };
                } else if (!_.isEmpty(dataValue)) {
                    obj = { ...dataValue, pending: false };
                } else {
                    obj = { pending: false };
                }
                formattedData.push(obj);
            }
            setAttendanceData(formattedData);
            setLoader(false)
        }
        catch (error) {
            console.error(error, "error");
            setLoader(false)
        }

    }

    const convertToRgba = (hex, alpha) => {
        hex = hex.replace('#', '');

        if (hex.length === 3) {
            hex = hex.split('').map(c => c + c).join('');
        }

        const bigint = parseInt(hex, 16);
        const r = (bigint >> 16) & 255;
        const g = (bigint >> 8) & 255;
        const b = bigint & 255;

        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }

    const dateTemplate = (singleDate) => {
        if (singleDate?.otherMonth) return;
        if (!singleDate?.otherMonth) {
            if (singleDate?.month !== calendarDate?.current?.month) {
                calendarDate.current = { month: singleDate?.month, year: singleDate?.year };
                getMyAttendanceSummary();
            }
        }
        const calen = new Date(new Date(singleDate?.year, singleDate?.month)?.setDate(singleDate?.day));
        const data = _.filter(attendanceData, item => dateConvert(item?.day_date) === dateConvert(calen))?.[0];
        if (!_.isEmpty(data)) {
            const taptickPending = ((data?.insights_starttime || data?.insights_endtime) && (data?.shift_startdate < data?.insights_starttime || data?.shift_enddate > data?.insights_endtime) && timeStringToDate('00:00:00', data?.day_date) < timeStringToDate('00:00:00', new Date()));

            return (
                <div className="wc-date-container bg-transparent" style={{ cursor: taptickPending && !data?.regularizarion_applied && userCode === data?.user_code ? "pointer" : "default" }}
                    onClick={(e) => {
                        const tooltipEl = e.currentTarget.querySelector('[data-bs-toggle="tooltip"]');
                        if (tooltipEl && tooltipEl._tooltipInstance) {
                            tooltipEl._tooltipInstance.hide();
                        }
                        if (taptickPending && !data?.regularizarion_applied && userCode === data?.user_code) {
                            setRegularizationPopup({ show: true, data: data });
                        }
                    }}>
                    <div className="badge-count d-flex fw-bold wc-dates each-day" title={data?.regularizarion_applied ? "Regularization Applied" : taptickPending ? "Apply Regularization " : ""}
                        style={{
                            background: `linear-gradient(to right, ${data?.first_half_color ? convertToRgba(data?.first_half_color, 0.5) : 'transparent'} 50%, ${data?.second_half_color ? convertToRgba(data?.second_half_color, 0.5) : 'transparent'} 50%)`,
                            border: `${((data?.insights_starttime || data?.insights_endtime) && (taptickPending && data?.regularizarion_applied)) ? "2px solid orange" : taptickPending && "2px solid red"} `
                        }}
                    >
                        <span className="position-absolute top-0 start-0 w50" />
                        <span className="position-absolute top-0 start-50 w50" />
                        <div className="d-flex align-items-center justify-content-center w100 " style={{ zIndex: 2 }} data-bs-toggle="tooltip"
                            title={(data?.is_weekly_off === 1 && !data?.actual_starttime) ?
                                "Weekly Off" :
                                (data?.is_holiday === 1 && !data?.actual_starttime) ?
                                    "Holiday" :
                                    `<div class="w100">
                                        <div class="d-flex justify-content-between" style="white-space: nowrap;">Shift Time : <div style="white-space: nowrap;">${data?.shift_startdate ? convertTo12HourFormat(data?.shift_startdate, "time") + " to " + convertTo12HourFormat(data?.shift_enddate, "time") : "-"}</div></div>
                                        <div class="d-flex justify-content-between" style="white-space: nowrap;">Actual Time : <div style="white-space: nowrap;">${data?.actual_starttime ? convertTo12HourFormat(data?.actual_starttime, "time") + " to " + (data?.actual_endtime ? convertTo12HourFormat(data?.actual_endtime, "time") : "") : "-"}</div></div>
                                        <div class="d-flex justify-content-between" style="white-space: nowrap;">Insights Time : <div style="white-space: nowrap;">${data?.insights_starttime ? convertTo12HourFormat(data?.insights_starttime, "time") + " to " + (data?.insights_endtime ? convertTo12HourFormat(data?.insights_endtime, "time") : "") : "-"}</div></div>
                                        <div class="d-flex justify-content-between" style="white-space: nowrap;">Working Hours : <div>${data?.working_hours || "-"}</div></div>
                                        <div class="d-flex justify-content-between" style="white-space: nowrap;">Un Punctual : <div>${((data?.is_punctual_in_time === 0 || data?.is_punctual_out_time === 0) && data?.actual_starttime) ? "Yes" : "No"}</div></div>
                                        <div class="d-flex justify-content-between" style="white-space: nowrap;">Extra Hours : <div>${data?.extra_hours || "-"}</div></div>
                                        <div class="d-flex justify-content-between" style="white-space: nowrap;">Deficit : <div>${data?.deficit || "-"}</div></div>
                                        <div class="d-flex justify-content-between" style="white-space: nowrap;">Regularized : <div>${data?.regularized === 1 ? "Yes" : "No"}</div></div>
                                        <div class="d-flex justify-content-between" style="white-space: nowrap;">Leave : <div>${data?.leave_status_name || "-"}</div></div>
                                        <div class="d-flex justify-content-between" style="white-space: nowrap;">WFH : <div>${data?.is_wfh === 1 ? "Yes" : "No"}</div></div>
                                        <div class="d-flex justify-content-between" style="white-space: nowrap;">GatePass Applied : <div>${data?.is_gatepass_applied === 1 ? "Yes" : "No"}</div></div>
                                        <div class="d-flex justify-content-between" style="white-space: nowrap;">In Remark : <div style="white-space: wrap;">${data?.in_remark || "-"}</div></div>
                                        <div class="d-flex justify-content-between" style="white-space: nowrap;">Out Remark : <div style="white-space: wrap;">${data?.out_remark || "-"}</div></div>
                                    </div>`
                            }
                            ref={(el) => {
                                if (!el) return;
                                const existing = Tooltip.getInstance(el);
                                if (existing) existing.dispose();
                                const tooltipInstance = new Tooltip(el, { html: true, sanitize: false, trigger: "hover", placement: "bottom", fallbackPlacements: [], customClass: "attendance-tooltip" });
                                el._tooltipInstance = tooltipInstance;
                                el.addEventListener("mouseenter", () => { tooltipInstance.show(); });
                                el.addEventListener("mouseleave", () => { tooltipInstance.hide(); });
                            }}
                        >
                            {singleDate?.day}{" "}
                        </div>
                        {
                            (data?.pending && timeStringToDate('00:00:00', data?.day_date) < timeStringToDate('00:00:00', new Date())) && <div className="position-absolute d-flex justify-content-center align-items-center color-black" title={data?.day_box_status} style={{ top: "10px", right: 0 }}>
                                <FontAwesomeIcon icon="fa-solid fa-circle-exclamation" />
                            </div>
                        }
                    </div>
                </div >
            )
        }
        return singleDate?.day;
    };

    return useMemo(() => ({
        date, setDate, loader, regularizationPopup, setRegularizationPopup, getMyAttendanceSummary, dateTemplate
    }), [date, setDate, loader, regularizationPopup, setRegularizationPopup, getMyAttendanceSummary, dateTemplate])
}